/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as PublicTenantFallbackRouteImport } from './routes/_public/tenant-fallback'
import { Route as PublicMaintenanceRouteImport } from './routes/_public/maintenance'
import { Route as PublicHelpDeskUnlogRouteImport } from './routes/_public/help-desk-unlog'
import { Route as PublicDownloadAppRouteImport } from './routes/_public/download-app'
import { Route as AuthUpdatePasswordRouteImport } from './routes/_auth/update-password'
import { Route as AuthSelectTenantRouteImport } from './routes/_auth/select-tenant'
import { Route as AuthRegisterOtpRouteImport } from './routes/_auth/register-otp'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthRecoveryPasswordRouteImport } from './routes/_auth/recovery-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthAccessPermissionsRouteImport } from './routes/_auth/access-permissions'
import { Route as AppVehiclesRouteImport } from './routes/_app/vehicles'
import { Route as AppUserGuideRouteImport } from './routes/_app/user-guide'
import { Route as AppUserAuditRouteImport } from './routes/_app/user-audit'
import { Route as AppUploadAttachmentsRouteImport } from './routes/_app/upload-attachments'
import { Route as AppUpdateAppRouteImport } from './routes/_app/update-app'
import { Route as AppTranslationsRouteImport } from './routes/_app/translations'
import { Route as AppTranslateStructureRouteImport } from './routes/_app/translate-structure'
import { Route as AppTicketsRouteImport } from './routes/_app/tickets'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppSwitchTenantRouteImport } from './routes/_app/switch-tenant'
import { Route as AppStatisticsRouteImport } from './routes/_app/statistics'
import { Route as AppSmartWorkingRouteImport } from './routes/_app/smart-working'
import { Route as AppSetupRouteImport } from './routes/_app/setup'
import { Route as AppReportingRouteImport } from './routes/_app/reporting'
import { Route as AppQualityRouteImport } from './routes/_app/quality'
import { Route as AppProjectForecastRouteImport } from './routes/_app/project-forecast'
import { Route as AppProductsRouteImport } from './routes/_app/products'
import { Route as AppPlanningRouteImport } from './routes/_app/planning'
import { Route as AppOpenAppRouteImport } from './routes/_app/open-app'
import { Route as AppOnboardingRouteImport } from './routes/_app/onboarding'
import { Route as AppMediaRouteImport } from './routes/_app/media'
import { Route as AppMaeworldRouteImport } from './routes/_app/maeworld'
import { Route as AppLicensingRouteImport } from './routes/_app/licensing'
import { Route as AppLegalsRouteImport } from './routes/_app/legals'
import { Route as AppLegalNoticesRouteImport } from './routes/_app/legal-notices'
import { Route as AppLeaveRouteImport } from './routes/_app/leave'
import { Route as AppIntercompanyRouteImport } from './routes/_app/intercompany'
import { Route as AppInstrumentsCalendarRouteImport } from './routes/_app/instruments-calendar'
import { Route as AppInsightsRouteImport } from './routes/_app/insights'
import { Route as AppHelpDeskAdminRouteImport } from './routes/_app/help-desk-admin'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppGeneralCrudRouteImport } from './routes/_app/general-crud'
import { Route as AppDeveloperGuideRouteImport } from './routes/_app/developer-guide'
import { Route as AppChangelogRouteImport } from './routes/_app/changelog'
import { Route as AppCategoriesRouteImport } from './routes/_app/categories'
import { Route as AppCarHistoryRouteImport } from './routes/_app/car-history'
import { Route as AppBillingRouteImport } from './routes/_app/billing'
import { Route as AppAttendanceRouteImport } from './routes/_app/attendance'
import { Route as AppArticlesRouteImport } from './routes/_app/articles'
import { Route as AppAboutRouteImport } from './routes/_app/about'
import { Route as AppWorkforceRouteRouteImport } from './routes/_app/workforce/route'
import { Route as AppUsersRouteRouteImport } from './routes/_app/users/route'
import { Route as AppTimesheetRouteRouteImport } from './routes/_app/timesheet/route'
import { Route as AppTemplatesRouteRouteImport } from './routes/_app/templates/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppRolesRouteRouteImport } from './routes/_app/roles/route'
import { Route as AppProjectsRouteRouteImport } from './routes/_app/projects/route'
import { Route as AppWorkforceIndexRouteImport } from './routes/_app/workforce/index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppTimesheetIndexRouteImport } from './routes/_app/timesheet/index'
import { Route as AppTemplatesIndexRouteImport } from './routes/_app/templates/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppRolesIndexRouteImport } from './routes/_app/roles/index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppCassaIndexRouteImport } from './routes/_app/cassa/index'
import { Route as PublicTermsCodeRouteImport } from './routes/_public/terms.$code'
import { Route as AppWorkforceTrainingRouteImport } from './routes/_app/workforce/training'
import { Route as AppWorkforceTodayRouteImport } from './routes/_app/workforce/today'
import { Route as AppWorkforceSitesRouteImport } from './routes/_app/workforce/sites'
import { Route as AppWorkforceSitePresencesRouteImport } from './routes/_app/workforce/site-presences'
import { Route as AppWorkforceRolesRouteImport } from './routes/_app/workforce/roles'
import { Route as AppWorkforceGroupsRouteImport } from './routes/_app/workforce/groups'
import { Route as AppWorkforceExternalRouteImport } from './routes/_app/workforce/external'
import { Route as AppWorkforceDashboardRouteImport } from './routes/_app/workforce/dashboard'
import { Route as AppWorkforceAreasRouteImport } from './routes/_app/workforce/areas'
import { Route as AppUsersNewRouteImport } from './routes/_app/users/new'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users/$userId'
import { Route as AppTimesheetReasonsRouteImport } from './routes/_app/timesheet/reasons'
import { Route as AppTimesheetByProjectRouteImport } from './routes/_app/timesheet/by-project'
import { Route as AppTimesheetApprovalRouteImport } from './routes/_app/timesheet/approval'
import { Route as AppTemplatesTemplateIdRouteImport } from './routes/_app/templates/$templateId'
import { Route as AppTasksKanbanRouteImport } from './routes/_app/tasks.kanban'
import { Route as AppTasksGanttRouteImport } from './routes/_app/tasks.gantt'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsPrivacyRouteImport } from './routes/_app/settings/privacy'
import { Route as AppSettingsPreferencesRouteImport } from './routes/_app/settings/preferences'
import { Route as AppSettingsNotificationPreferencesRouteImport } from './routes/_app/settings/notification-preferences'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsDevicesRouteImport } from './routes/_app/settings/devices'
import { Route as AppSettingsApiKeysRouteImport } from './routes/_app/settings/api-keys'
import { Route as AppSecretaryAreaRouteImport } from './routes/_app/secretary.area'
import { Route as AppRolesRoleIdRouteImport } from './routes/_app/roles/$roleId'
import { Route as AppProjectsNewRouteImport } from './routes/_app/projects/new'
import { Route as AppProjectsGanttRouteImport } from './routes/_app/projects/gantt'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'
import { Route as AppInsightsMonthlyInvoicesRouteImport } from './routes/_app/insights.monthly-invoices'
import { Route as AppBookingsCarHistoryRouteImport } from './routes/_app/bookings/car-history'
import { Route as AppArticlesIdRouteImport } from './routes/_app/articles.$id'
import { Route as AppAdminWorkingHoursRouteImport } from './routes/_app/admin/working-hours'
import { Route as AppAdminTranslateStructureRouteImport } from './routes/_app/admin.translate-structure'
import { Route as AppAdminTenantManagementRouteImport } from './routes/_app/admin/tenant-management'
import { Route as AppAdminSystemRouteImport } from './routes/_app/admin.system'
import { Route as AppAdminStructureLabelsRouteImport } from './routes/_app/admin/structure-labels'
import { Route as AppAdminSendCommunicationsRouteImport } from './routes/_app/admin.send-communications'
import { Route as AppAdminLicensesCatalogRouteImport } from './routes/_app/admin/licenses-catalog'
import { Route as AppAdminLicensePlansRouteImport } from './routes/_app/admin/license-plans'
import { Route as AppAdminLicenseDashboardRouteImport } from './routes/_app/admin.license-dashboard'
import { Route as AppAdminHelpDeskRouteImport } from './routes/_app/admin.help-desk'
import { Route as AppAdminCrossTenantAccessLogsRouteImport } from './routes/_app/admin.cross-tenant-access-logs'
import { Route as AppAdminCategoriesRouteImport } from './routes/_app/admin.categories'
import { Route as AppAdminBrandingRouteImport } from './routes/_app/admin/branding'
import { Route as AppAdminAuditLogRouteImport } from './routes/_app/admin/audit-log'
import { Route as AppAdminTenantsIndexRouteImport } from './routes/_app/admin/tenants/index'
import { Route as AppProjectsProjectIdDashboardRouteImport } from './routes/_app/projects/$projectId.dashboard'
import { Route as AppAdminTenantsTenantIdRouteImport } from './routes/_app/admin/tenants/$tenantId'
import { Route as AppAdminTenantsTenantIdSubscriptionRouteImport } from './routes/_app/admin/tenants/$tenantId.subscription'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const PublicTenantFallbackRoute = PublicTenantFallbackRouteImport.update({
  id: '/tenant-fallback',
  path: '/tenant-fallback',
  getParentRoute: () => PublicRoute,
} as any)
const PublicMaintenanceRoute = PublicMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => PublicRoute,
} as any)
const PublicHelpDeskUnlogRoute = PublicHelpDeskUnlogRouteImport.update({
  id: '/help-desk-unlog',
  path: '/help-desk-unlog',
  getParentRoute: () => PublicRoute,
} as any)
const PublicDownloadAppRoute = PublicDownloadAppRouteImport.update({
  id: '/download-app',
  path: '/download-app',
  getParentRoute: () => PublicRoute,
} as any)
const AuthUpdatePasswordRoute = AuthUpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSelectTenantRoute = AuthSelectTenantRouteImport.update({
  id: '/select-tenant',
  path: '/select-tenant',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterOtpRoute = AuthRegisterOtpRouteImport.update({
  id: '/register-otp',
  path: '/register-otp',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecoveryPasswordRoute = AuthRecoveryPasswordRouteImport.update({
  id: '/recovery-password',
  path: '/recovery-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccessPermissionsRoute = AuthAccessPermissionsRouteImport.update({
  id: '/access-permissions',
  path: '/access-permissions',
  getParentRoute: () => AuthRoute,
} as any)
const AppVehiclesRoute = AppVehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => AppRoute,
} as any)
const AppUserGuideRoute = AppUserGuideRouteImport.update({
  id: '/user-guide',
  path: '/user-guide',
  getParentRoute: () => AppRoute,
} as any)
const AppUserAuditRoute = AppUserAuditRouteImport.update({
  id: '/user-audit',
  path: '/user-audit',
  getParentRoute: () => AppRoute,
} as any)
const AppUploadAttachmentsRoute = AppUploadAttachmentsRouteImport.update({
  id: '/upload-attachments',
  path: '/upload-attachments',
  getParentRoute: () => AppRoute,
} as any)
const AppUpdateAppRoute = AppUpdateAppRouteImport.update({
  id: '/update-app',
  path: '/update-app',
  getParentRoute: () => AppRoute,
} as any)
const AppTranslationsRoute = AppTranslationsRouteImport.update({
  id: '/translations',
  path: '/translations',
  getParentRoute: () => AppRoute,
} as any)
const AppTranslateStructureRoute = AppTranslateStructureRouteImport.update({
  id: '/translate-structure',
  path: '/translate-structure',
  getParentRoute: () => AppRoute,
} as any)
const AppTicketsRoute = AppTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppSwitchTenantRoute = AppSwitchTenantRouteImport.update({
  id: '/switch-tenant',
  path: '/switch-tenant',
  getParentRoute: () => AppRoute,
} as any)
const AppStatisticsRoute = AppStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AppRoute,
} as any)
const AppSmartWorkingRoute = AppSmartWorkingRouteImport.update({
  id: '/smart-working',
  path: '/smart-working',
  getParentRoute: () => AppRoute,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppReportingRoute = AppReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => AppRoute,
} as any)
const AppQualityRoute = AppQualityRouteImport.update({
  id: '/quality',
  path: '/quality',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectForecastRoute = AppProjectForecastRouteImport.update({
  id: '/project-forecast',
  path: '/project-forecast',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsRoute = AppProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanningRoute = AppPlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AppRoute,
} as any)
const AppOpenAppRoute = AppOpenAppRouteImport.update({
  id: '/open-app',
  path: '/open-app',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppMediaRoute = AppMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AppRoute,
} as any)
const AppMaeworldRoute = AppMaeworldRouteImport.update({
  id: '/maeworld',
  path: '/maeworld',
  getParentRoute: () => AppRoute,
} as any)
const AppLicensingRoute = AppLicensingRouteImport.update({
  id: '/licensing',
  path: '/licensing',
  getParentRoute: () => AppRoute,
} as any)
const AppLegalsRoute = AppLegalsRouteImport.update({
  id: '/legals',
  path: '/legals',
  getParentRoute: () => AppRoute,
} as any)
const AppLegalNoticesRoute = AppLegalNoticesRouteImport.update({
  id: '/legal-notices',
  path: '/legal-notices',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaveRoute = AppLeaveRouteImport.update({
  id: '/leave',
  path: '/leave',
  getParentRoute: () => AppRoute,
} as any)
const AppIntercompanyRoute = AppIntercompanyRouteImport.update({
  id: '/intercompany',
  path: '/intercompany',
  getParentRoute: () => AppRoute,
} as any)
const AppInstrumentsCalendarRoute = AppInstrumentsCalendarRouteImport.update({
  id: '/instruments-calendar',
  path: '/instruments-calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpDeskAdminRoute = AppHelpDeskAdminRouteImport.update({
  id: '/help-desk-admin',
  path: '/help-desk-admin',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppGeneralCrudRoute = AppGeneralCrudRouteImport.update({
  id: '/general-crud',
  path: '/general-crud',
  getParentRoute: () => AppRoute,
} as any)
const AppDeveloperGuideRoute = AppDeveloperGuideRouteImport.update({
  id: '/developer-guide',
  path: '/developer-guide',
  getParentRoute: () => AppRoute,
} as any)
const AppChangelogRoute = AppChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AppRoute,
} as any)
const AppCategoriesRoute = AppCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppCarHistoryRoute = AppCarHistoryRouteImport.update({
  id: '/car-history',
  path: '/car-history',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppAttendanceRoute = AppAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AppRoute,
} as any)
const AppArticlesRoute = AppArticlesRouteImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => AppRoute,
} as any)
const AppAboutRoute = AppAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforceRouteRoute = AppWorkforceRouteRouteImport.update({
  id: '/workforce',
  path: '/workforce',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRouteRoute = AppUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppTimesheetRouteRoute = AppTimesheetRouteRouteImport.update({
  id: '/timesheet',
  path: '/timesheet',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRouteRoute = AppTemplatesRouteRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRolesRouteRoute = AppRolesRouteRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRouteRoute = AppProjectsRouteRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppWorkforceIndexRoute = AppWorkforceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppTimesheetIndexRoute = AppTimesheetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTemplatesIndexRoute = AppTemplatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTemplatesRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppRolesIndexRoute = AppRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRolesRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppCassaIndexRoute = AppCassaIndexRouteImport.update({
  id: '/cassa/',
  path: '/cassa/',
  getParentRoute: () => AppRoute,
} as any)
const PublicTermsCodeRoute = PublicTermsCodeRouteImport.update({
  id: '/terms/$code',
  path: '/terms/$code',
  getParentRoute: () => PublicRoute,
} as any)
const AppWorkforceTrainingRoute = AppWorkforceTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceTodayRoute = AppWorkforceTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceSitesRoute = AppWorkforceSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceSitePresencesRoute =
  AppWorkforceSitePresencesRouteImport.update({
    id: '/site-presences',
    path: '/site-presences',
    getParentRoute: () => AppWorkforceRouteRoute,
  } as any)
const AppWorkforceRolesRoute = AppWorkforceRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceGroupsRoute = AppWorkforceGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceExternalRoute = AppWorkforceExternalRouteImport.update({
  id: '/external',
  path: '/external',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceDashboardRoute = AppWorkforceDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppWorkforceAreasRoute = AppWorkforceAreasRouteImport.update({
  id: '/areas',
  path: '/areas',
  getParentRoute: () => AppWorkforceRouteRoute,
} as any)
const AppUsersNewRoute = AppUsersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AppUsersRouteRoute,
} as any)
const AppTimesheetReasonsRoute = AppTimesheetReasonsRouteImport.update({
  id: '/reasons',
  path: '/reasons',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTimesheetByProjectRoute = AppTimesheetByProjectRouteImport.update({
  id: '/by-project',
  path: '/by-project',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTimesheetApprovalRoute = AppTimesheetApprovalRouteImport.update({
  id: '/approval',
  path: '/approval',
  getParentRoute: () => AppTimesheetRouteRoute,
} as any)
const AppTemplatesTemplateIdRoute = AppTemplatesTemplateIdRouteImport.update({
  id: '/$templateId',
  path: '/$templateId',
  getParentRoute: () => AppTemplatesRouteRoute,
} as any)
const AppTasksKanbanRoute = AppTasksKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppTasksGanttRoute = AppTasksGanttRouteImport.update({
  id: '/gantt',
  path: '/gantt',
  getParentRoute: () => AppTasksRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPreferencesRoute = AppSettingsPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationPreferencesRoute =
  AppSettingsNotificationPreferencesRouteImport.update({
    id: '/notification-preferences',
    path: '/notification-preferences',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDevicesRoute = AppSettingsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsApiKeysRoute = AppSettingsApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSecretaryAreaRoute = AppSecretaryAreaRouteImport.update({
  id: '/secretary/area',
  path: '/secretary/area',
  getParentRoute: () => AppRoute,
} as any)
const AppRolesRoleIdRoute = AppRolesRoleIdRouteImport.update({
  id: '/$roleId',
  path: '/$roleId',
  getParentRoute: () => AppRolesRouteRoute,
} as any)
const AppProjectsNewRoute = AppProjectsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsGanttRoute = AppProjectsGanttRouteImport.update({
  id: '/gantt',
  path: '/gantt',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => AppProjectsRouteRoute,
} as any)
const AppInsightsMonthlyInvoicesRoute =
  AppInsightsMonthlyInvoicesRouteImport.update({
    id: '/monthly-invoices',
    path: '/monthly-invoices',
    getParentRoute: () => AppInsightsRoute,
  } as any)
const AppBookingsCarHistoryRoute = AppBookingsCarHistoryRouteImport.update({
  id: '/bookings/car-history',
  path: '/bookings/car-history',
  getParentRoute: () => AppRoute,
} as any)
const AppArticlesIdRoute = AppArticlesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppArticlesRoute,
} as any)
const AppAdminWorkingHoursRoute = AppAdminWorkingHoursRouteImport.update({
  id: '/admin/working-hours',
  path: '/admin/working-hours',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTranslateStructureRoute =
  AppAdminTranslateStructureRouteImport.update({
    id: '/admin/translate-structure',
    path: '/admin/translate-structure',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminTenantManagementRoute =
  AppAdminTenantManagementRouteImport.update({
    id: '/admin/tenant-management',
    path: '/admin/tenant-management',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminSystemRoute = AppAdminSystemRouteImport.update({
  id: '/admin/system',
  path: '/admin/system',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminStructureLabelsRoute = AppAdminStructureLabelsRouteImport.update({
  id: '/admin/structure-labels',
  path: '/admin/structure-labels',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSendCommunicationsRoute =
  AppAdminSendCommunicationsRouteImport.update({
    id: '/admin/send-communications',
    path: '/admin/send-communications',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminLicensesCatalogRoute = AppAdminLicensesCatalogRouteImport.update({
  id: '/admin/licenses-catalog',
  path: '/admin/licenses-catalog',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLicensePlansRoute = AppAdminLicensePlansRouteImport.update({
  id: '/admin/license-plans',
  path: '/admin/license-plans',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminLicenseDashboardRoute =
  AppAdminLicenseDashboardRouteImport.update({
    id: '/admin/license-dashboard',
    path: '/admin/license-dashboard',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminHelpDeskRoute = AppAdminHelpDeskRouteImport.update({
  id: '/admin/help-desk',
  path: '/admin/help-desk',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminCrossTenantAccessLogsRoute =
  AppAdminCrossTenantAccessLogsRouteImport.update({
    id: '/admin/cross-tenant-access-logs',
    path: '/admin/cross-tenant-access-logs',
    getParentRoute: () => AppRoute,
  } as any)
const AppAdminCategoriesRoute = AppAdminCategoriesRouteImport.update({
  id: '/admin/categories',
  path: '/admin/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminBrandingRoute = AppAdminBrandingRouteImport.update({
  id: '/admin/branding',
  path: '/admin/branding',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAuditLogRoute = AppAdminAuditLogRouteImport.update({
  id: '/admin/audit-log',
  path: '/admin/audit-log',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTenantsIndexRoute = AppAdminTenantsIndexRouteImport.update({
  id: '/admin/tenants/',
  path: '/admin/tenants/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdDashboardRoute =
  AppProjectsProjectIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppAdminTenantsTenantIdRoute = AppAdminTenantsTenantIdRouteImport.update({
  id: '/admin/tenants/$tenantId',
  path: '/admin/tenants/$tenantId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTenantsTenantIdSubscriptionRoute =
  AppAdminTenantsTenantIdSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AppAdminTenantsTenantIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/projects': typeof AppProjectsRouteRouteWithChildren
  '/roles': typeof AppRolesRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/templates': typeof AppTemplatesRouteRouteWithChildren
  '/timesheet': typeof AppTimesheetRouteRouteWithChildren
  '/users': typeof AppUsersRouteRouteWithChildren
  '/workforce': typeof AppWorkforceRouteRouteWithChildren
  '/about': typeof AppAboutRoute
  '/articles': typeof AppArticlesRouteWithChildren
  '/attendance': typeof AppAttendanceRoute
  '/billing': typeof AppBillingRoute
  '/car-history': typeof AppCarHistoryRoute
  '/categories': typeof AppCategoriesRoute
  '/changelog': typeof AppChangelogRoute
  '/developer-guide': typeof AppDeveloperGuideRoute
  '/general-crud': typeof AppGeneralCrudRoute
  '/help': typeof AppHelpRoute
  '/help-desk-admin': typeof AppHelpDeskAdminRoute
  '/insights': typeof AppInsightsRouteWithChildren
  '/instruments-calendar': typeof AppInstrumentsCalendarRoute
  '/intercompany': typeof AppIntercompanyRoute
  '/leave': typeof AppLeaveRoute
  '/legal-notices': typeof AppLegalNoticesRoute
  '/legals': typeof AppLegalsRoute
  '/licensing': typeof AppLicensingRoute
  '/maeworld': typeof AppMaeworldRoute
  '/media': typeof AppMediaRoute
  '/onboarding': typeof AppOnboardingRoute
  '/open-app': typeof AppOpenAppRoute
  '/planning': typeof AppPlanningRoute
  '/products': typeof AppProductsRoute
  '/project-forecast': typeof AppProjectForecastRoute
  '/quality': typeof AppQualityRoute
  '/reporting': typeof AppReportingRoute
  '/setup': typeof AppSetupRoute
  '/smart-working': typeof AppSmartWorkingRoute
  '/statistics': typeof AppStatisticsRoute
  '/switch-tenant': typeof AppSwitchTenantRoute
  '/tasks': typeof AppTasksRouteWithChildren
  '/tickets': typeof AppTicketsRoute
  '/translate-structure': typeof AppTranslateStructureRoute
  '/translations': typeof AppTranslationsRoute
  '/update-app': typeof AppUpdateAppRoute
  '/upload-attachments': typeof AppUploadAttachmentsRoute
  '/user-audit': typeof AppUserAuditRoute
  '/user-guide': typeof AppUserGuideRoute
  '/vehicles': typeof AppVehiclesRoute
  '/access-permissions': typeof AuthAccessPermissionsRoute
  '/login': typeof AuthLoginRoute
  '/recovery-password': typeof AuthRecoveryPasswordRoute
  '/register': typeof AuthRegisterRoute
  '/register-otp': typeof AuthRegisterOtpRoute
  '/select-tenant': typeof AuthSelectTenantRoute
  '/update-password': typeof AuthUpdatePasswordRoute
  '/download-app': typeof PublicDownloadAppRoute
  '/help-desk-unlog': typeof PublicHelpDeskUnlogRoute
  '/maintenance': typeof PublicMaintenanceRoute
  '/tenant-fallback': typeof PublicTenantFallbackRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/branding': typeof AppAdminBrandingRoute
  '/admin/categories': typeof AppAdminCategoriesRoute
  '/admin/cross-tenant-access-logs': typeof AppAdminCrossTenantAccessLogsRoute
  '/admin/help-desk': typeof AppAdminHelpDeskRoute
  '/admin/license-dashboard': typeof AppAdminLicenseDashboardRoute
  '/admin/license-plans': typeof AppAdminLicensePlansRoute
  '/admin/licenses-catalog': typeof AppAdminLicensesCatalogRoute
  '/admin/send-communications': typeof AppAdminSendCommunicationsRoute
  '/admin/structure-labels': typeof AppAdminStructureLabelsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/admin/tenant-management': typeof AppAdminTenantManagementRoute
  '/admin/translate-structure': typeof AppAdminTranslateStructureRoute
  '/admin/working-hours': typeof AppAdminWorkingHoursRoute
  '/articles/$id': typeof AppArticlesIdRoute
  '/bookings/car-history': typeof AppBookingsCarHistoryRoute
  '/insights/monthly-invoices': typeof AppInsightsMonthlyInvoicesRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/projects/gantt': typeof AppProjectsGanttRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/roles/$roleId': typeof AppRolesRoleIdRoute
  '/secretary/area': typeof AppSecretaryAreaRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/devices': typeof AppSettingsDevicesRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/notification-preferences': typeof AppSettingsNotificationPreferencesRoute
  '/settings/preferences': typeof AppSettingsPreferencesRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/tasks/gantt': typeof AppTasksGanttRoute
  '/tasks/kanban': typeof AppTasksKanbanRoute
  '/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/timesheet/approval': typeof AppTimesheetApprovalRoute
  '/timesheet/by-project': typeof AppTimesheetByProjectRoute
  '/timesheet/reasons': typeof AppTimesheetReasonsRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/users/new': typeof AppUsersNewRoute
  '/workforce/areas': typeof AppWorkforceAreasRoute
  '/workforce/dashboard': typeof AppWorkforceDashboardRoute
  '/workforce/external': typeof AppWorkforceExternalRoute
  '/workforce/groups': typeof AppWorkforceGroupsRoute
  '/workforce/roles': typeof AppWorkforceRolesRoute
  '/workforce/site-presences': typeof AppWorkforceSitePresencesRoute
  '/workforce/sites': typeof AppWorkforceSitesRoute
  '/workforce/today': typeof AppWorkforceTodayRoute
  '/workforce/training': typeof AppWorkforceTrainingRoute
  '/terms/$code': typeof PublicTermsCodeRoute
  '/cassa/': typeof AppCassaIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/roles/': typeof AppRolesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/templates/': typeof AppTemplatesIndexRoute
  '/timesheet/': typeof AppTimesheetIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/workforce/': typeof AppWorkforceIndexRoute
  '/admin/tenants/$tenantId': typeof AppAdminTenantsTenantIdRouteWithChildren
  '/projects/$projectId/dashboard': typeof AppProjectsProjectIdDashboardRoute
  '/admin/tenants/': typeof AppAdminTenantsIndexRoute
  '/admin/tenants/$tenantId/subscription': typeof AppAdminTenantsTenantIdSubscriptionRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/about': typeof AppAboutRoute
  '/articles': typeof AppArticlesRouteWithChildren
  '/attendance': typeof AppAttendanceRoute
  '/billing': typeof AppBillingRoute
  '/car-history': typeof AppCarHistoryRoute
  '/categories': typeof AppCategoriesRoute
  '/changelog': typeof AppChangelogRoute
  '/developer-guide': typeof AppDeveloperGuideRoute
  '/general-crud': typeof AppGeneralCrudRoute
  '/help': typeof AppHelpRoute
  '/help-desk-admin': typeof AppHelpDeskAdminRoute
  '/insights': typeof AppInsightsRouteWithChildren
  '/instruments-calendar': typeof AppInstrumentsCalendarRoute
  '/intercompany': typeof AppIntercompanyRoute
  '/leave': typeof AppLeaveRoute
  '/legal-notices': typeof AppLegalNoticesRoute
  '/legals': typeof AppLegalsRoute
  '/licensing': typeof AppLicensingRoute
  '/maeworld': typeof AppMaeworldRoute
  '/media': typeof AppMediaRoute
  '/onboarding': typeof AppOnboardingRoute
  '/open-app': typeof AppOpenAppRoute
  '/planning': typeof AppPlanningRoute
  '/products': typeof AppProductsRoute
  '/project-forecast': typeof AppProjectForecastRoute
  '/quality': typeof AppQualityRoute
  '/reporting': typeof AppReportingRoute
  '/setup': typeof AppSetupRoute
  '/smart-working': typeof AppSmartWorkingRoute
  '/statistics': typeof AppStatisticsRoute
  '/switch-tenant': typeof AppSwitchTenantRoute
  '/tasks': typeof AppTasksRouteWithChildren
  '/tickets': typeof AppTicketsRoute
  '/translate-structure': typeof AppTranslateStructureRoute
  '/translations': typeof AppTranslationsRoute
  '/update-app': typeof AppUpdateAppRoute
  '/upload-attachments': typeof AppUploadAttachmentsRoute
  '/user-audit': typeof AppUserAuditRoute
  '/user-guide': typeof AppUserGuideRoute
  '/vehicles': typeof AppVehiclesRoute
  '/access-permissions': typeof AuthAccessPermissionsRoute
  '/login': typeof AuthLoginRoute
  '/recovery-password': typeof AuthRecoveryPasswordRoute
  '/register': typeof AuthRegisterRoute
  '/register-otp': typeof AuthRegisterOtpRoute
  '/select-tenant': typeof AuthSelectTenantRoute
  '/update-password': typeof AuthUpdatePasswordRoute
  '/download-app': typeof PublicDownloadAppRoute
  '/help-desk-unlog': typeof PublicHelpDeskUnlogRoute
  '/maintenance': typeof PublicMaintenanceRoute
  '/tenant-fallback': typeof PublicTenantFallbackRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/branding': typeof AppAdminBrandingRoute
  '/admin/categories': typeof AppAdminCategoriesRoute
  '/admin/cross-tenant-access-logs': typeof AppAdminCrossTenantAccessLogsRoute
  '/admin/help-desk': typeof AppAdminHelpDeskRoute
  '/admin/license-dashboard': typeof AppAdminLicenseDashboardRoute
  '/admin/license-plans': typeof AppAdminLicensePlansRoute
  '/admin/licenses-catalog': typeof AppAdminLicensesCatalogRoute
  '/admin/send-communications': typeof AppAdminSendCommunicationsRoute
  '/admin/structure-labels': typeof AppAdminStructureLabelsRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/admin/tenant-management': typeof AppAdminTenantManagementRoute
  '/admin/translate-structure': typeof AppAdminTranslateStructureRoute
  '/admin/working-hours': typeof AppAdminWorkingHoursRoute
  '/articles/$id': typeof AppArticlesIdRoute
  '/bookings/car-history': typeof AppBookingsCarHistoryRoute
  '/insights/monthly-invoices': typeof AppInsightsMonthlyInvoicesRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/projects/gantt': typeof AppProjectsGanttRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/roles/$roleId': typeof AppRolesRoleIdRoute
  '/secretary/area': typeof AppSecretaryAreaRoute
  '/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/settings/devices': typeof AppSettingsDevicesRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/notification-preferences': typeof AppSettingsNotificationPreferencesRoute
  '/settings/preferences': typeof AppSettingsPreferencesRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/tasks/gantt': typeof AppTasksGanttRoute
  '/tasks/kanban': typeof AppTasksKanbanRoute
  '/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/timesheet/approval': typeof AppTimesheetApprovalRoute
  '/timesheet/by-project': typeof AppTimesheetByProjectRoute
  '/timesheet/reasons': typeof AppTimesheetReasonsRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/users/new': typeof AppUsersNewRoute
  '/workforce/areas': typeof AppWorkforceAreasRoute
  '/workforce/dashboard': typeof AppWorkforceDashboardRoute
  '/workforce/external': typeof AppWorkforceExternalRoute
  '/workforce/groups': typeof AppWorkforceGroupsRoute
  '/workforce/roles': typeof AppWorkforceRolesRoute
  '/workforce/site-presences': typeof AppWorkforceSitePresencesRoute
  '/workforce/sites': typeof AppWorkforceSitesRoute
  '/workforce/today': typeof AppWorkforceTodayRoute
  '/workforce/training': typeof AppWorkforceTrainingRoute
  '/terms/$code': typeof PublicTermsCodeRoute
  '/cassa': typeof AppCassaIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/roles': typeof AppRolesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/templates': typeof AppTemplatesIndexRoute
  '/timesheet': typeof AppTimesheetIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/workforce': typeof AppWorkforceIndexRoute
  '/admin/tenants/$tenantId': typeof AppAdminTenantsTenantIdRouteWithChildren
  '/projects/$projectId/dashboard': typeof AppProjectsProjectIdDashboardRoute
  '/admin/tenants': typeof AppAdminTenantsIndexRoute
  '/admin/tenants/$tenantId/subscription': typeof AppAdminTenantsTenantIdSubscriptionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_app/projects': typeof AppProjectsRouteRouteWithChildren
  '/_app/roles': typeof AppRolesRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/templates': typeof AppTemplatesRouteRouteWithChildren
  '/_app/timesheet': typeof AppTimesheetRouteRouteWithChildren
  '/_app/users': typeof AppUsersRouteRouteWithChildren
  '/_app/workforce': typeof AppWorkforceRouteRouteWithChildren
  '/_app/about': typeof AppAboutRoute
  '/_app/articles': typeof AppArticlesRouteWithChildren
  '/_app/attendance': typeof AppAttendanceRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/car-history': typeof AppCarHistoryRoute
  '/_app/categories': typeof AppCategoriesRoute
  '/_app/changelog': typeof AppChangelogRoute
  '/_app/developer-guide': typeof AppDeveloperGuideRoute
  '/_app/general-crud': typeof AppGeneralCrudRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/help-desk-admin': typeof AppHelpDeskAdminRoute
  '/_app/insights': typeof AppInsightsRouteWithChildren
  '/_app/instruments-calendar': typeof AppInstrumentsCalendarRoute
  '/_app/intercompany': typeof AppIntercompanyRoute
  '/_app/leave': typeof AppLeaveRoute
  '/_app/legal-notices': typeof AppLegalNoticesRoute
  '/_app/legals': typeof AppLegalsRoute
  '/_app/licensing': typeof AppLicensingRoute
  '/_app/maeworld': typeof AppMaeworldRoute
  '/_app/media': typeof AppMediaRoute
  '/_app/onboarding': typeof AppOnboardingRoute
  '/_app/open-app': typeof AppOpenAppRoute
  '/_app/planning': typeof AppPlanningRoute
  '/_app/products': typeof AppProductsRoute
  '/_app/project-forecast': typeof AppProjectForecastRoute
  '/_app/quality': typeof AppQualityRoute
  '/_app/reporting': typeof AppReportingRoute
  '/_app/setup': typeof AppSetupRoute
  '/_app/smart-working': typeof AppSmartWorkingRoute
  '/_app/statistics': typeof AppStatisticsRoute
  '/_app/switch-tenant': typeof AppSwitchTenantRoute
  '/_app/tasks': typeof AppTasksRouteWithChildren
  '/_app/tickets': typeof AppTicketsRoute
  '/_app/translate-structure': typeof AppTranslateStructureRoute
  '/_app/translations': typeof AppTranslationsRoute
  '/_app/update-app': typeof AppUpdateAppRoute
  '/_app/upload-attachments': typeof AppUploadAttachmentsRoute
  '/_app/user-audit': typeof AppUserAuditRoute
  '/_app/user-guide': typeof AppUserGuideRoute
  '/_app/vehicles': typeof AppVehiclesRoute
  '/_auth/access-permissions': typeof AuthAccessPermissionsRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/recovery-password': typeof AuthRecoveryPasswordRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/register-otp': typeof AuthRegisterOtpRoute
  '/_auth/select-tenant': typeof AuthSelectTenantRoute
  '/_auth/update-password': typeof AuthUpdatePasswordRoute
  '/_public/download-app': typeof PublicDownloadAppRoute
  '/_public/help-desk-unlog': typeof PublicHelpDeskUnlogRoute
  '/_public/maintenance': typeof PublicMaintenanceRoute
  '/_public/tenant-fallback': typeof PublicTenantFallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/audit-log': typeof AppAdminAuditLogRoute
  '/_app/admin/branding': typeof AppAdminBrandingRoute
  '/_app/admin/categories': typeof AppAdminCategoriesRoute
  '/_app/admin/cross-tenant-access-logs': typeof AppAdminCrossTenantAccessLogsRoute
  '/_app/admin/help-desk': typeof AppAdminHelpDeskRoute
  '/_app/admin/license-dashboard': typeof AppAdminLicenseDashboardRoute
  '/_app/admin/license-plans': typeof AppAdminLicensePlansRoute
  '/_app/admin/licenses-catalog': typeof AppAdminLicensesCatalogRoute
  '/_app/admin/send-communications': typeof AppAdminSendCommunicationsRoute
  '/_app/admin/structure-labels': typeof AppAdminStructureLabelsRoute
  '/_app/admin/system': typeof AppAdminSystemRoute
  '/_app/admin/tenant-management': typeof AppAdminTenantManagementRoute
  '/_app/admin/translate-structure': typeof AppAdminTranslateStructureRoute
  '/_app/admin/working-hours': typeof AppAdminWorkingHoursRoute
  '/_app/articles/$id': typeof AppArticlesIdRoute
  '/_app/bookings/car-history': typeof AppBookingsCarHistoryRoute
  '/_app/insights/monthly-invoices': typeof AppInsightsMonthlyInvoicesRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/_app/projects/gantt': typeof AppProjectsGanttRoute
  '/_app/projects/new': typeof AppProjectsNewRoute
  '/_app/roles/$roleId': typeof AppRolesRoleIdRoute
  '/_app/secretary/area': typeof AppSecretaryAreaRoute
  '/_app/settings/api-keys': typeof AppSettingsApiKeysRoute
  '/_app/settings/devices': typeof AppSettingsDevicesRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/notification-preferences': typeof AppSettingsNotificationPreferencesRoute
  '/_app/settings/preferences': typeof AppSettingsPreferencesRoute
  '/_app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/tasks/gantt': typeof AppTasksGanttRoute
  '/_app/tasks/kanban': typeof AppTasksKanbanRoute
  '/_app/templates/$templateId': typeof AppTemplatesTemplateIdRoute
  '/_app/timesheet/approval': typeof AppTimesheetApprovalRoute
  '/_app/timesheet/by-project': typeof AppTimesheetByProjectRoute
  '/_app/timesheet/reasons': typeof AppTimesheetReasonsRoute
  '/_app/users/$userId': typeof AppUsersUserIdRoute
  '/_app/users/new': typeof AppUsersNewRoute
  '/_app/workforce/areas': typeof AppWorkforceAreasRoute
  '/_app/workforce/dashboard': typeof AppWorkforceDashboardRoute
  '/_app/workforce/external': typeof AppWorkforceExternalRoute
  '/_app/workforce/groups': typeof AppWorkforceGroupsRoute
  '/_app/workforce/roles': typeof AppWorkforceRolesRoute
  '/_app/workforce/site-presences': typeof AppWorkforceSitePresencesRoute
  '/_app/workforce/sites': typeof AppWorkforceSitesRoute
  '/_app/workforce/today': typeof AppWorkforceTodayRoute
  '/_app/workforce/training': typeof AppWorkforceTrainingRoute
  '/_public/terms/$code': typeof PublicTermsCodeRoute
  '/_app/cassa/': typeof AppCassaIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/roles/': typeof AppRolesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/templates/': typeof AppTemplatesIndexRoute
  '/_app/timesheet/': typeof AppTimesheetIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/workforce/': typeof AppWorkforceIndexRoute
  '/_app/admin/tenants/$tenantId': typeof AppAdminTenantsTenantIdRouteWithChildren
  '/_app/projects/$projectId/dashboard': typeof AppProjectsProjectIdDashboardRoute
  '/_app/admin/tenants/': typeof AppAdminTenantsIndexRoute
  '/_app/admin/tenants/$tenantId/subscription': typeof AppAdminTenantsTenantIdSubscriptionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/projects'
    | '/roles'
    | '/settings'
    | '/templates'
    | '/timesheet'
    | '/users'
    | '/workforce'
    | '/about'
    | '/articles'
    | '/attendance'
    | '/billing'
    | '/car-history'
    | '/categories'
    | '/changelog'
    | '/developer-guide'
    | '/general-crud'
    | '/help'
    | '/help-desk-admin'
    | '/insights'
    | '/instruments-calendar'
    | '/intercompany'
    | '/leave'
    | '/legal-notices'
    | '/legals'
    | '/licensing'
    | '/maeworld'
    | '/media'
    | '/onboarding'
    | '/open-app'
    | '/planning'
    | '/products'
    | '/project-forecast'
    | '/quality'
    | '/reporting'
    | '/setup'
    | '/smart-working'
    | '/statistics'
    | '/switch-tenant'
    | '/tasks'
    | '/tickets'
    | '/translate-structure'
    | '/translations'
    | '/update-app'
    | '/upload-attachments'
    | '/user-audit'
    | '/user-guide'
    | '/vehicles'
    | '/access-permissions'
    | '/login'
    | '/recovery-password'
    | '/register'
    | '/register-otp'
    | '/select-tenant'
    | '/update-password'
    | '/download-app'
    | '/help-desk-unlog'
    | '/maintenance'
    | '/tenant-fallback'
    | '/admin/audit-log'
    | '/admin/branding'
    | '/admin/categories'
    | '/admin/cross-tenant-access-logs'
    | '/admin/help-desk'
    | '/admin/license-dashboard'
    | '/admin/license-plans'
    | '/admin/licenses-catalog'
    | '/admin/send-communications'
    | '/admin/structure-labels'
    | '/admin/system'
    | '/admin/tenant-management'
    | '/admin/translate-structure'
    | '/admin/working-hours'
    | '/articles/$id'
    | '/bookings/car-history'
    | '/insights/monthly-invoices'
    | '/projects/$projectId'
    | '/projects/gantt'
    | '/projects/new'
    | '/roles/$roleId'
    | '/secretary/area'
    | '/settings/api-keys'
    | '/settings/devices'
    | '/settings/integrations'
    | '/settings/notification-preferences'
    | '/settings/preferences'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/security'
    | '/tasks/gantt'
    | '/tasks/kanban'
    | '/templates/$templateId'
    | '/timesheet/approval'
    | '/timesheet/by-project'
    | '/timesheet/reasons'
    | '/users/$userId'
    | '/users/new'
    | '/workforce/areas'
    | '/workforce/dashboard'
    | '/workforce/external'
    | '/workforce/groups'
    | '/workforce/roles'
    | '/workforce/site-presences'
    | '/workforce/sites'
    | '/workforce/today'
    | '/workforce/training'
    | '/terms/$code'
    | '/cassa/'
    | '/projects/'
    | '/roles/'
    | '/settings/'
    | '/templates/'
    | '/timesheet/'
    | '/users/'
    | '/workforce/'
    | '/admin/tenants/$tenantId'
    | '/projects/$projectId/dashboard'
    | '/admin/tenants/'
    | '/admin/tenants/$tenantId/subscription'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/articles'
    | '/attendance'
    | '/billing'
    | '/car-history'
    | '/categories'
    | '/changelog'
    | '/developer-guide'
    | '/general-crud'
    | '/help'
    | '/help-desk-admin'
    | '/insights'
    | '/instruments-calendar'
    | '/intercompany'
    | '/leave'
    | '/legal-notices'
    | '/legals'
    | '/licensing'
    | '/maeworld'
    | '/media'
    | '/onboarding'
    | '/open-app'
    | '/planning'
    | '/products'
    | '/project-forecast'
    | '/quality'
    | '/reporting'
    | '/setup'
    | '/smart-working'
    | '/statistics'
    | '/switch-tenant'
    | '/tasks'
    | '/tickets'
    | '/translate-structure'
    | '/translations'
    | '/update-app'
    | '/upload-attachments'
    | '/user-audit'
    | '/user-guide'
    | '/vehicles'
    | '/access-permissions'
    | '/login'
    | '/recovery-password'
    | '/register'
    | '/register-otp'
    | '/select-tenant'
    | '/update-password'
    | '/download-app'
    | '/help-desk-unlog'
    | '/maintenance'
    | '/tenant-fallback'
    | '/admin/audit-log'
    | '/admin/branding'
    | '/admin/categories'
    | '/admin/cross-tenant-access-logs'
    | '/admin/help-desk'
    | '/admin/license-dashboard'
    | '/admin/license-plans'
    | '/admin/licenses-catalog'
    | '/admin/send-communications'
    | '/admin/structure-labels'
    | '/admin/system'
    | '/admin/tenant-management'
    | '/admin/translate-structure'
    | '/admin/working-hours'
    | '/articles/$id'
    | '/bookings/car-history'
    | '/insights/monthly-invoices'
    | '/projects/$projectId'
    | '/projects/gantt'
    | '/projects/new'
    | '/roles/$roleId'
    | '/secretary/area'
    | '/settings/api-keys'
    | '/settings/devices'
    | '/settings/integrations'
    | '/settings/notification-preferences'
    | '/settings/preferences'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/security'
    | '/tasks/gantt'
    | '/tasks/kanban'
    | '/templates/$templateId'
    | '/timesheet/approval'
    | '/timesheet/by-project'
    | '/timesheet/reasons'
    | '/users/$userId'
    | '/users/new'
    | '/workforce/areas'
    | '/workforce/dashboard'
    | '/workforce/external'
    | '/workforce/groups'
    | '/workforce/roles'
    | '/workforce/site-presences'
    | '/workforce/sites'
    | '/workforce/today'
    | '/workforce/training'
    | '/terms/$code'
    | '/cassa'
    | '/projects'
    | '/roles'
    | '/settings'
    | '/templates'
    | '/timesheet'
    | '/users'
    | '/workforce'
    | '/admin/tenants/$tenantId'
    | '/projects/$projectId/dashboard'
    | '/admin/tenants'
    | '/admin/tenants/$tenantId/subscription'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/_public'
    | '/_app/projects'
    | '/_app/roles'
    | '/_app/settings'
    | '/_app/templates'
    | '/_app/timesheet'
    | '/_app/users'
    | '/_app/workforce'
    | '/_app/about'
    | '/_app/articles'
    | '/_app/attendance'
    | '/_app/billing'
    | '/_app/car-history'
    | '/_app/categories'
    | '/_app/changelog'
    | '/_app/developer-guide'
    | '/_app/general-crud'
    | '/_app/help'
    | '/_app/help-desk-admin'
    | '/_app/insights'
    | '/_app/instruments-calendar'
    | '/_app/intercompany'
    | '/_app/leave'
    | '/_app/legal-notices'
    | '/_app/legals'
    | '/_app/licensing'
    | '/_app/maeworld'
    | '/_app/media'
    | '/_app/onboarding'
    | '/_app/open-app'
    | '/_app/planning'
    | '/_app/products'
    | '/_app/project-forecast'
    | '/_app/quality'
    | '/_app/reporting'
    | '/_app/setup'
    | '/_app/smart-working'
    | '/_app/statistics'
    | '/_app/switch-tenant'
    | '/_app/tasks'
    | '/_app/tickets'
    | '/_app/translate-structure'
    | '/_app/translations'
    | '/_app/update-app'
    | '/_app/upload-attachments'
    | '/_app/user-audit'
    | '/_app/user-guide'
    | '/_app/vehicles'
    | '/_auth/access-permissions'
    | '/_auth/login'
    | '/_auth/recovery-password'
    | '/_auth/register'
    | '/_auth/register-otp'
    | '/_auth/select-tenant'
    | '/_auth/update-password'
    | '/_public/download-app'
    | '/_public/help-desk-unlog'
    | '/_public/maintenance'
    | '/_public/tenant-fallback'
    | '/_app/'
    | '/_app/admin/audit-log'
    | '/_app/admin/branding'
    | '/_app/admin/categories'
    | '/_app/admin/cross-tenant-access-logs'
    | '/_app/admin/help-desk'
    | '/_app/admin/license-dashboard'
    | '/_app/admin/license-plans'
    | '/_app/admin/licenses-catalog'
    | '/_app/admin/send-communications'
    | '/_app/admin/structure-labels'
    | '/_app/admin/system'
    | '/_app/admin/tenant-management'
    | '/_app/admin/translate-structure'
    | '/_app/admin/working-hours'
    | '/_app/articles/$id'
    | '/_app/bookings/car-history'
    | '/_app/insights/monthly-invoices'
    | '/_app/projects/$projectId'
    | '/_app/projects/gantt'
    | '/_app/projects/new'
    | '/_app/roles/$roleId'
    | '/_app/secretary/area'
    | '/_app/settings/api-keys'
    | '/_app/settings/devices'
    | '/_app/settings/integrations'
    | '/_app/settings/notification-preferences'
    | '/_app/settings/preferences'
    | '/_app/settings/privacy'
    | '/_app/settings/profile'
    | '/_app/settings/security'
    | '/_app/tasks/gantt'
    | '/_app/tasks/kanban'
    | '/_app/templates/$templateId'
    | '/_app/timesheet/approval'
    | '/_app/timesheet/by-project'
    | '/_app/timesheet/reasons'
    | '/_app/users/$userId'
    | '/_app/users/new'
    | '/_app/workforce/areas'
    | '/_app/workforce/dashboard'
    | '/_app/workforce/external'
    | '/_app/workforce/groups'
    | '/_app/workforce/roles'
    | '/_app/workforce/site-presences'
    | '/_app/workforce/sites'
    | '/_app/workforce/today'
    | '/_app/workforce/training'
    | '/_public/terms/$code'
    | '/_app/cassa/'
    | '/_app/projects/'
    | '/_app/roles/'
    | '/_app/settings/'
    | '/_app/templates/'
    | '/_app/timesheet/'
    | '/_app/users/'
    | '/_app/workforce/'
    | '/_app/admin/tenants/$tenantId'
    | '/_app/projects/$projectId/dashboard'
    | '/_app/admin/tenants/'
    | '/_app/admin/tenants/$tenantId/subscription'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/tenant-fallback': {
      id: '/_public/tenant-fallback'
      path: '/tenant-fallback'
      fullPath: '/tenant-fallback'
      preLoaderRoute: typeof PublicTenantFallbackRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/maintenance': {
      id: '/_public/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof PublicMaintenanceRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/help-desk-unlog': {
      id: '/_public/help-desk-unlog'
      path: '/help-desk-unlog'
      fullPath: '/help-desk-unlog'
      preLoaderRoute: typeof PublicHelpDeskUnlogRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/download-app': {
      id: '/_public/download-app'
      path: '/download-app'
      fullPath: '/download-app'
      preLoaderRoute: typeof PublicDownloadAppRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/update-password': {
      id: '/_auth/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof AuthUpdatePasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/select-tenant': {
      id: '/_auth/select-tenant'
      path: '/select-tenant'
      fullPath: '/select-tenant'
      preLoaderRoute: typeof AuthSelectTenantRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register-otp': {
      id: '/_auth/register-otp'
      path: '/register-otp'
      fullPath: '/register-otp'
      preLoaderRoute: typeof AuthRegisterOtpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recovery-password': {
      id: '/_auth/recovery-password'
      path: '/recovery-password'
      fullPath: '/recovery-password'
      preLoaderRoute: typeof AuthRecoveryPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/access-permissions': {
      id: '/_auth/access-permissions'
      path: '/access-permissions'
      fullPath: '/access-permissions'
      preLoaderRoute: typeof AuthAccessPermissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/vehicles': {
      id: '/_app/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof AppVehiclesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/user-guide': {
      id: '/_app/user-guide'
      path: '/user-guide'
      fullPath: '/user-guide'
      preLoaderRoute: typeof AppUserGuideRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/user-audit': {
      id: '/_app/user-audit'
      path: '/user-audit'
      fullPath: '/user-audit'
      preLoaderRoute: typeof AppUserAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/upload-attachments': {
      id: '/_app/upload-attachments'
      path: '/upload-attachments'
      fullPath: '/upload-attachments'
      preLoaderRoute: typeof AppUploadAttachmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/update-app': {
      id: '/_app/update-app'
      path: '/update-app'
      fullPath: '/update-app'
      preLoaderRoute: typeof AppUpdateAppRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/translations': {
      id: '/_app/translations'
      path: '/translations'
      fullPath: '/translations'
      preLoaderRoute: typeof AppTranslationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/translate-structure': {
      id: '/_app/translate-structure'
      path: '/translate-structure'
      fullPath: '/translate-structure'
      preLoaderRoute: typeof AppTranslateStructureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tickets': {
      id: '/_app/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AppTicketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/switch-tenant': {
      id: '/_app/switch-tenant'
      path: '/switch-tenant'
      fullPath: '/switch-tenant'
      preLoaderRoute: typeof AppSwitchTenantRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/statistics': {
      id: '/_app/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AppStatisticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smart-working': {
      id: '/_app/smart-working'
      path: '/smart-working'
      fullPath: '/smart-working'
      preLoaderRoute: typeof AppSmartWorkingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reporting': {
      id: '/_app/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AppReportingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/quality': {
      id: '/_app/quality'
      path: '/quality'
      fullPath: '/quality'
      preLoaderRoute: typeof AppQualityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/project-forecast': {
      id: '/_app/project-forecast'
      path: '/project-forecast'
      fullPath: '/project-forecast'
      preLoaderRoute: typeof AppProjectForecastRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products': {
      id: '/_app/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning': {
      id: '/_app/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof AppPlanningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/open-app': {
      id: '/_app/open-app'
      path: '/open-app'
      fullPath: '/open-app'
      preLoaderRoute: typeof AppOpenAppRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/media': {
      id: '/_app/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof AppMediaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/maeworld': {
      id: '/_app/maeworld'
      path: '/maeworld'
      fullPath: '/maeworld'
      preLoaderRoute: typeof AppMaeworldRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/licensing': {
      id: '/_app/licensing'
      path: '/licensing'
      fullPath: '/licensing'
      preLoaderRoute: typeof AppLicensingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/legals': {
      id: '/_app/legals'
      path: '/legals'
      fullPath: '/legals'
      preLoaderRoute: typeof AppLegalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/legal-notices': {
      id: '/_app/legal-notices'
      path: '/legal-notices'
      fullPath: '/legal-notices'
      preLoaderRoute: typeof AppLegalNoticesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leave': {
      id: '/_app/leave'
      path: '/leave'
      fullPath: '/leave'
      preLoaderRoute: typeof AppLeaveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/intercompany': {
      id: '/_app/intercompany'
      path: '/intercompany'
      fullPath: '/intercompany'
      preLoaderRoute: typeof AppIntercompanyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/instruments-calendar': {
      id: '/_app/instruments-calendar'
      path: '/instruments-calendar'
      fullPath: '/instruments-calendar'
      preLoaderRoute: typeof AppInstrumentsCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/insights': {
      id: '/_app/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help-desk-admin': {
      id: '/_app/help-desk-admin'
      path: '/help-desk-admin'
      fullPath: '/help-desk-admin'
      preLoaderRoute: typeof AppHelpDeskAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/general-crud': {
      id: '/_app/general-crud'
      path: '/general-crud'
      fullPath: '/general-crud'
      preLoaderRoute: typeof AppGeneralCrudRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/developer-guide': {
      id: '/_app/developer-guide'
      path: '/developer-guide'
      fullPath: '/developer-guide'
      preLoaderRoute: typeof AppDeveloperGuideRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/changelog': {
      id: '/_app/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AppChangelogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/categories': {
      id: '/_app/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AppCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/car-history': {
      id: '/_app/car-history'
      path: '/car-history'
      fullPath: '/car-history'
      preLoaderRoute: typeof AppCarHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/attendance': {
      id: '/_app/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof AppAttendanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/articles': {
      id: '/_app/articles'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof AppArticlesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/about': {
      id: '/_app/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AppAboutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce': {
      id: '/_app/workforce'
      path: '/workforce'
      fullPath: '/workforce'
      preLoaderRoute: typeof AppWorkforceRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timesheet': {
      id: '/_app/timesheet'
      path: '/timesheet'
      fullPath: '/timesheet'
      preLoaderRoute: typeof AppTimesheetRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles': {
      id: '/_app/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AppRolesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/workforce/': {
      id: '/_app/workforce/'
      path: '/'
      fullPath: '/workforce/'
      preLoaderRoute: typeof AppWorkforceIndexRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/timesheet/': {
      id: '/_app/timesheet/'
      path: '/'
      fullPath: '/timesheet/'
      preLoaderRoute: typeof AppTimesheetIndexRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/templates/': {
      id: '/_app/templates/'
      path: '/'
      fullPath: '/templates/'
      preLoaderRoute: typeof AppTemplatesIndexRouteImport
      parentRoute: typeof AppTemplatesRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/roles/': {
      id: '/_app/roles/'
      path: '/'
      fullPath: '/roles/'
      preLoaderRoute: typeof AppRolesIndexRouteImport
      parentRoute: typeof AppRolesRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/cassa/': {
      id: '/_app/cassa/'
      path: '/cassa'
      fullPath: '/cassa/'
      preLoaderRoute: typeof AppCassaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/terms/$code': {
      id: '/_public/terms/$code'
      path: '/terms/$code'
      fullPath: '/terms/$code'
      preLoaderRoute: typeof PublicTermsCodeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/workforce/training': {
      id: '/_app/workforce/training'
      path: '/training'
      fullPath: '/workforce/training'
      preLoaderRoute: typeof AppWorkforceTrainingRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/today': {
      id: '/_app/workforce/today'
      path: '/today'
      fullPath: '/workforce/today'
      preLoaderRoute: typeof AppWorkforceTodayRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/sites': {
      id: '/_app/workforce/sites'
      path: '/sites'
      fullPath: '/workforce/sites'
      preLoaderRoute: typeof AppWorkforceSitesRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/site-presences': {
      id: '/_app/workforce/site-presences'
      path: '/site-presences'
      fullPath: '/workforce/site-presences'
      preLoaderRoute: typeof AppWorkforceSitePresencesRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/roles': {
      id: '/_app/workforce/roles'
      path: '/roles'
      fullPath: '/workforce/roles'
      preLoaderRoute: typeof AppWorkforceRolesRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/groups': {
      id: '/_app/workforce/groups'
      path: '/groups'
      fullPath: '/workforce/groups'
      preLoaderRoute: typeof AppWorkforceGroupsRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/external': {
      id: '/_app/workforce/external'
      path: '/external'
      fullPath: '/workforce/external'
      preLoaderRoute: typeof AppWorkforceExternalRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/dashboard': {
      id: '/_app/workforce/dashboard'
      path: '/dashboard'
      fullPath: '/workforce/dashboard'
      preLoaderRoute: typeof AppWorkforceDashboardRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/workforce/areas': {
      id: '/_app/workforce/areas'
      path: '/areas'
      fullPath: '/workforce/areas'
      preLoaderRoute: typeof AppWorkforceAreasRouteImport
      parentRoute: typeof AppWorkforceRouteRoute
    }
    '/_app/users/new': {
      id: '/_app/users/new'
      path: '/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AppUsersNewRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/users/$userId': {
      id: '/_app/users/$userId'
      path: '/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppUsersRouteRoute
    }
    '/_app/timesheet/reasons': {
      id: '/_app/timesheet/reasons'
      path: '/reasons'
      fullPath: '/timesheet/reasons'
      preLoaderRoute: typeof AppTimesheetReasonsRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/timesheet/by-project': {
      id: '/_app/timesheet/by-project'
      path: '/by-project'
      fullPath: '/timesheet/by-project'
      preLoaderRoute: typeof AppTimesheetByProjectRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/timesheet/approval': {
      id: '/_app/timesheet/approval'
      path: '/approval'
      fullPath: '/timesheet/approval'
      preLoaderRoute: typeof AppTimesheetApprovalRouteImport
      parentRoute: typeof AppTimesheetRouteRoute
    }
    '/_app/templates/$templateId': {
      id: '/_app/templates/$templateId'
      path: '/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AppTemplatesTemplateIdRouteImport
      parentRoute: typeof AppTemplatesRouteRoute
    }
    '/_app/tasks/kanban': {
      id: '/_app/tasks/kanban'
      path: '/kanban'
      fullPath: '/tasks/kanban'
      preLoaderRoute: typeof AppTasksKanbanRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/tasks/gantt': {
      id: '/_app/tasks/gantt'
      path: '/gantt'
      fullPath: '/tasks/gantt'
      preLoaderRoute: typeof AppTasksGanttRouteImport
      parentRoute: typeof AppTasksRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/privacy': {
      id: '/_app/settings/privacy'
      path: '/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/preferences': {
      id: '/_app/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof AppSettingsPreferencesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/notification-preferences': {
      id: '/_app/settings/notification-preferences'
      path: '/notification-preferences'
      fullPath: '/settings/notification-preferences'
      preLoaderRoute: typeof AppSettingsNotificationPreferencesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/devices': {
      id: '/_app/settings/devices'
      path: '/devices'
      fullPath: '/settings/devices'
      preLoaderRoute: typeof AppSettingsDevicesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/api-keys': {
      id: '/_app/settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AppSettingsApiKeysRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/secretary/area': {
      id: '/_app/secretary/area'
      path: '/secretary/area'
      fullPath: '/secretary/area'
      preLoaderRoute: typeof AppSecretaryAreaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles/$roleId': {
      id: '/_app/roles/$roleId'
      path: '/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AppRolesRoleIdRouteImport
      parentRoute: typeof AppRolesRouteRoute
    }
    '/_app/projects/new': {
      id: '/_app/projects/new'
      path: '/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AppProjectsNewRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/gantt': {
      id: '/_app/projects/gantt'
      path: '/gantt'
      fullPath: '/projects/gantt'
      preLoaderRoute: typeof AppProjectsGanttRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppProjectsRouteRoute
    }
    '/_app/insights/monthly-invoices': {
      id: '/_app/insights/monthly-invoices'
      path: '/monthly-invoices'
      fullPath: '/insights/monthly-invoices'
      preLoaderRoute: typeof AppInsightsMonthlyInvoicesRouteImport
      parentRoute: typeof AppInsightsRoute
    }
    '/_app/bookings/car-history': {
      id: '/_app/bookings/car-history'
      path: '/bookings/car-history'
      fullPath: '/bookings/car-history'
      preLoaderRoute: typeof AppBookingsCarHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/articles/$id': {
      id: '/_app/articles/$id'
      path: '/$id'
      fullPath: '/articles/$id'
      preLoaderRoute: typeof AppArticlesIdRouteImport
      parentRoute: typeof AppArticlesRoute
    }
    '/_app/admin/working-hours': {
      id: '/_app/admin/working-hours'
      path: '/admin/working-hours'
      fullPath: '/admin/working-hours'
      preLoaderRoute: typeof AppAdminWorkingHoursRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/translate-structure': {
      id: '/_app/admin/translate-structure'
      path: '/admin/translate-structure'
      fullPath: '/admin/translate-structure'
      preLoaderRoute: typeof AppAdminTranslateStructureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenant-management': {
      id: '/_app/admin/tenant-management'
      path: '/admin/tenant-management'
      fullPath: '/admin/tenant-management'
      preLoaderRoute: typeof AppAdminTenantManagementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/system': {
      id: '/_app/admin/system'
      path: '/admin/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AppAdminSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/structure-labels': {
      id: '/_app/admin/structure-labels'
      path: '/admin/structure-labels'
      fullPath: '/admin/structure-labels'
      preLoaderRoute: typeof AppAdminStructureLabelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/send-communications': {
      id: '/_app/admin/send-communications'
      path: '/admin/send-communications'
      fullPath: '/admin/send-communications'
      preLoaderRoute: typeof AppAdminSendCommunicationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/licenses-catalog': {
      id: '/_app/admin/licenses-catalog'
      path: '/admin/licenses-catalog'
      fullPath: '/admin/licenses-catalog'
      preLoaderRoute: typeof AppAdminLicensesCatalogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/license-plans': {
      id: '/_app/admin/license-plans'
      path: '/admin/license-plans'
      fullPath: '/admin/license-plans'
      preLoaderRoute: typeof AppAdminLicensePlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/license-dashboard': {
      id: '/_app/admin/license-dashboard'
      path: '/admin/license-dashboard'
      fullPath: '/admin/license-dashboard'
      preLoaderRoute: typeof AppAdminLicenseDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/help-desk': {
      id: '/_app/admin/help-desk'
      path: '/admin/help-desk'
      fullPath: '/admin/help-desk'
      preLoaderRoute: typeof AppAdminHelpDeskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/cross-tenant-access-logs': {
      id: '/_app/admin/cross-tenant-access-logs'
      path: '/admin/cross-tenant-access-logs'
      fullPath: '/admin/cross-tenant-access-logs'
      preLoaderRoute: typeof AppAdminCrossTenantAccessLogsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/categories': {
      id: '/_app/admin/categories'
      path: '/admin/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AppAdminCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/branding': {
      id: '/_app/admin/branding'
      path: '/admin/branding'
      fullPath: '/admin/branding'
      preLoaderRoute: typeof AppAdminBrandingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/audit-log': {
      id: '/_app/admin/audit-log'
      path: '/admin/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AppAdminAuditLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenants/': {
      id: '/_app/admin/tenants/'
      path: '/admin/tenants'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AppAdminTenantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId/dashboard': {
      id: '/_app/projects/$projectId/dashboard'
      path: '/dashboard'
      fullPath: '/projects/$projectId/dashboard'
      preLoaderRoute: typeof AppProjectsProjectIdDashboardRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/admin/tenants/$tenantId': {
      id: '/_app/admin/tenants/$tenantId'
      path: '/admin/tenants/$tenantId'
      fullPath: '/admin/tenants/$tenantId'
      preLoaderRoute: typeof AppAdminTenantsTenantIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/tenants/$tenantId/subscription': {
      id: '/_app/admin/tenants/$tenantId/subscription'
      path: '/subscription'
      fullPath: '/admin/tenants/$tenantId/subscription'
      preLoaderRoute: typeof AppAdminTenantsTenantIdSubscriptionRouteImport
      parentRoute: typeof AppAdminTenantsTenantIdRoute
    }
  }
}

interface AppProjectsProjectIdRouteChildren {
  AppProjectsProjectIdDashboardRoute: typeof AppProjectsProjectIdDashboardRoute
}

const AppProjectsProjectIdRouteChildren: AppProjectsProjectIdRouteChildren = {
  AppProjectsProjectIdDashboardRoute: AppProjectsProjectIdDashboardRoute,
}

const AppProjectsProjectIdRouteWithChildren =
  AppProjectsProjectIdRoute._addFileChildren(AppProjectsProjectIdRouteChildren)

interface AppProjectsRouteRouteChildren {
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRouteWithChildren
  AppProjectsGanttRoute: typeof AppProjectsGanttRoute
  AppProjectsNewRoute: typeof AppProjectsNewRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppProjectsRouteRouteChildren: AppProjectsRouteRouteChildren = {
  AppProjectsProjectIdRoute: AppProjectsProjectIdRouteWithChildren,
  AppProjectsGanttRoute: AppProjectsGanttRoute,
  AppProjectsNewRoute: AppProjectsNewRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppProjectsRouteRouteWithChildren =
  AppProjectsRouteRoute._addFileChildren(AppProjectsRouteRouteChildren)

interface AppRolesRouteRouteChildren {
  AppRolesRoleIdRoute: typeof AppRolesRoleIdRoute
  AppRolesIndexRoute: typeof AppRolesIndexRoute
}

const AppRolesRouteRouteChildren: AppRolesRouteRouteChildren = {
  AppRolesRoleIdRoute: AppRolesRoleIdRoute,
  AppRolesIndexRoute: AppRolesIndexRoute,
}

const AppRolesRouteRouteWithChildren = AppRolesRouteRoute._addFileChildren(
  AppRolesRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsApiKeysRoute: typeof AppSettingsApiKeysRoute
  AppSettingsDevicesRoute: typeof AppSettingsDevicesRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsNotificationPreferencesRoute: typeof AppSettingsNotificationPreferencesRoute
  AppSettingsPreferencesRoute: typeof AppSettingsPreferencesRoute
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsApiKeysRoute: AppSettingsApiKeysRoute,
  AppSettingsDevicesRoute: AppSettingsDevicesRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsNotificationPreferencesRoute:
    AppSettingsNotificationPreferencesRoute,
  AppSettingsPreferencesRoute: AppSettingsPreferencesRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppTemplatesRouteRouteChildren {
  AppTemplatesTemplateIdRoute: typeof AppTemplatesTemplateIdRoute
  AppTemplatesIndexRoute: typeof AppTemplatesIndexRoute
}

const AppTemplatesRouteRouteChildren: AppTemplatesRouteRouteChildren = {
  AppTemplatesTemplateIdRoute: AppTemplatesTemplateIdRoute,
  AppTemplatesIndexRoute: AppTemplatesIndexRoute,
}

const AppTemplatesRouteRouteWithChildren =
  AppTemplatesRouteRoute._addFileChildren(AppTemplatesRouteRouteChildren)

interface AppTimesheetRouteRouteChildren {
  AppTimesheetApprovalRoute: typeof AppTimesheetApprovalRoute
  AppTimesheetByProjectRoute: typeof AppTimesheetByProjectRoute
  AppTimesheetReasonsRoute: typeof AppTimesheetReasonsRoute
  AppTimesheetIndexRoute: typeof AppTimesheetIndexRoute
}

const AppTimesheetRouteRouteChildren: AppTimesheetRouteRouteChildren = {
  AppTimesheetApprovalRoute: AppTimesheetApprovalRoute,
  AppTimesheetByProjectRoute: AppTimesheetByProjectRoute,
  AppTimesheetReasonsRoute: AppTimesheetReasonsRoute,
  AppTimesheetIndexRoute: AppTimesheetIndexRoute,
}

const AppTimesheetRouteRouteWithChildren =
  AppTimesheetRouteRoute._addFileChildren(AppTimesheetRouteRouteChildren)

interface AppUsersRouteRouteChildren {
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppUsersNewRoute: typeof AppUsersNewRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppUsersRouteRouteChildren: AppUsersRouteRouteChildren = {
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppUsersNewRoute: AppUsersNewRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppUsersRouteRouteWithChildren = AppUsersRouteRoute._addFileChildren(
  AppUsersRouteRouteChildren,
)

interface AppWorkforceRouteRouteChildren {
  AppWorkforceAreasRoute: typeof AppWorkforceAreasRoute
  AppWorkforceDashboardRoute: typeof AppWorkforceDashboardRoute
  AppWorkforceExternalRoute: typeof AppWorkforceExternalRoute
  AppWorkforceGroupsRoute: typeof AppWorkforceGroupsRoute
  AppWorkforceRolesRoute: typeof AppWorkforceRolesRoute
  AppWorkforceSitePresencesRoute: typeof AppWorkforceSitePresencesRoute
  AppWorkforceSitesRoute: typeof AppWorkforceSitesRoute
  AppWorkforceTodayRoute: typeof AppWorkforceTodayRoute
  AppWorkforceTrainingRoute: typeof AppWorkforceTrainingRoute
  AppWorkforceIndexRoute: typeof AppWorkforceIndexRoute
}

const AppWorkforceRouteRouteChildren: AppWorkforceRouteRouteChildren = {
  AppWorkforceAreasRoute: AppWorkforceAreasRoute,
  AppWorkforceDashboardRoute: AppWorkforceDashboardRoute,
  AppWorkforceExternalRoute: AppWorkforceExternalRoute,
  AppWorkforceGroupsRoute: AppWorkforceGroupsRoute,
  AppWorkforceRolesRoute: AppWorkforceRolesRoute,
  AppWorkforceSitePresencesRoute: AppWorkforceSitePresencesRoute,
  AppWorkforceSitesRoute: AppWorkforceSitesRoute,
  AppWorkforceTodayRoute: AppWorkforceTodayRoute,
  AppWorkforceTrainingRoute: AppWorkforceTrainingRoute,
  AppWorkforceIndexRoute: AppWorkforceIndexRoute,
}

const AppWorkforceRouteRouteWithChildren =
  AppWorkforceRouteRoute._addFileChildren(AppWorkforceRouteRouteChildren)

interface AppArticlesRouteChildren {
  AppArticlesIdRoute: typeof AppArticlesIdRoute
}

const AppArticlesRouteChildren: AppArticlesRouteChildren = {
  AppArticlesIdRoute: AppArticlesIdRoute,
}

const AppArticlesRouteWithChildren = AppArticlesRoute._addFileChildren(
  AppArticlesRouteChildren,
)

interface AppInsightsRouteChildren {
  AppInsightsMonthlyInvoicesRoute: typeof AppInsightsMonthlyInvoicesRoute
}

const AppInsightsRouteChildren: AppInsightsRouteChildren = {
  AppInsightsMonthlyInvoicesRoute: AppInsightsMonthlyInvoicesRoute,
}

const AppInsightsRouteWithChildren = AppInsightsRoute._addFileChildren(
  AppInsightsRouteChildren,
)

interface AppTasksRouteChildren {
  AppTasksGanttRoute: typeof AppTasksGanttRoute
  AppTasksKanbanRoute: typeof AppTasksKanbanRoute
}

const AppTasksRouteChildren: AppTasksRouteChildren = {
  AppTasksGanttRoute: AppTasksGanttRoute,
  AppTasksKanbanRoute: AppTasksKanbanRoute,
}

const AppTasksRouteWithChildren = AppTasksRoute._addFileChildren(
  AppTasksRouteChildren,
)

interface AppAdminTenantsTenantIdRouteChildren {
  AppAdminTenantsTenantIdSubscriptionRoute: typeof AppAdminTenantsTenantIdSubscriptionRoute
}

const AppAdminTenantsTenantIdRouteChildren: AppAdminTenantsTenantIdRouteChildren =
  {
    AppAdminTenantsTenantIdSubscriptionRoute:
      AppAdminTenantsTenantIdSubscriptionRoute,
  }

const AppAdminTenantsTenantIdRouteWithChildren =
  AppAdminTenantsTenantIdRoute._addFileChildren(
    AppAdminTenantsTenantIdRouteChildren,
  )

interface AppRouteChildren {
  AppProjectsRouteRoute: typeof AppProjectsRouteRouteWithChildren
  AppRolesRouteRoute: typeof AppRolesRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppTemplatesRouteRoute: typeof AppTemplatesRouteRouteWithChildren
  AppTimesheetRouteRoute: typeof AppTimesheetRouteRouteWithChildren
  AppUsersRouteRoute: typeof AppUsersRouteRouteWithChildren
  AppWorkforceRouteRoute: typeof AppWorkforceRouteRouteWithChildren
  AppAboutRoute: typeof AppAboutRoute
  AppArticlesRoute: typeof AppArticlesRouteWithChildren
  AppAttendanceRoute: typeof AppAttendanceRoute
  AppBillingRoute: typeof AppBillingRoute
  AppCarHistoryRoute: typeof AppCarHistoryRoute
  AppCategoriesRoute: typeof AppCategoriesRoute
  AppChangelogRoute: typeof AppChangelogRoute
  AppDeveloperGuideRoute: typeof AppDeveloperGuideRoute
  AppGeneralCrudRoute: typeof AppGeneralCrudRoute
  AppHelpRoute: typeof AppHelpRoute
  AppHelpDeskAdminRoute: typeof AppHelpDeskAdminRoute
  AppInsightsRoute: typeof AppInsightsRouteWithChildren
  AppInstrumentsCalendarRoute: typeof AppInstrumentsCalendarRoute
  AppIntercompanyRoute: typeof AppIntercompanyRoute
  AppLeaveRoute: typeof AppLeaveRoute
  AppLegalNoticesRoute: typeof AppLegalNoticesRoute
  AppLegalsRoute: typeof AppLegalsRoute
  AppLicensingRoute: typeof AppLicensingRoute
  AppMaeworldRoute: typeof AppMaeworldRoute
  AppMediaRoute: typeof AppMediaRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppOpenAppRoute: typeof AppOpenAppRoute
  AppPlanningRoute: typeof AppPlanningRoute
  AppProductsRoute: typeof AppProductsRoute
  AppProjectForecastRoute: typeof AppProjectForecastRoute
  AppQualityRoute: typeof AppQualityRoute
  AppReportingRoute: typeof AppReportingRoute
  AppSetupRoute: typeof AppSetupRoute
  AppSmartWorkingRoute: typeof AppSmartWorkingRoute
  AppStatisticsRoute: typeof AppStatisticsRoute
  AppSwitchTenantRoute: typeof AppSwitchTenantRoute
  AppTasksRoute: typeof AppTasksRouteWithChildren
  AppTicketsRoute: typeof AppTicketsRoute
  AppTranslateStructureRoute: typeof AppTranslateStructureRoute
  AppTranslationsRoute: typeof AppTranslationsRoute
  AppUpdateAppRoute: typeof AppUpdateAppRoute
  AppUploadAttachmentsRoute: typeof AppUploadAttachmentsRoute
  AppUserAuditRoute: typeof AppUserAuditRoute
  AppUserGuideRoute: typeof AppUserGuideRoute
  AppVehiclesRoute: typeof AppVehiclesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminAuditLogRoute: typeof AppAdminAuditLogRoute
  AppAdminBrandingRoute: typeof AppAdminBrandingRoute
  AppAdminCategoriesRoute: typeof AppAdminCategoriesRoute
  AppAdminCrossTenantAccessLogsRoute: typeof AppAdminCrossTenantAccessLogsRoute
  AppAdminHelpDeskRoute: typeof AppAdminHelpDeskRoute
  AppAdminLicenseDashboardRoute: typeof AppAdminLicenseDashboardRoute
  AppAdminLicensePlansRoute: typeof AppAdminLicensePlansRoute
  AppAdminLicensesCatalogRoute: typeof AppAdminLicensesCatalogRoute
  AppAdminSendCommunicationsRoute: typeof AppAdminSendCommunicationsRoute
  AppAdminStructureLabelsRoute: typeof AppAdminStructureLabelsRoute
  AppAdminSystemRoute: typeof AppAdminSystemRoute
  AppAdminTenantManagementRoute: typeof AppAdminTenantManagementRoute
  AppAdminTranslateStructureRoute: typeof AppAdminTranslateStructureRoute
  AppAdminWorkingHoursRoute: typeof AppAdminWorkingHoursRoute
  AppBookingsCarHistoryRoute: typeof AppBookingsCarHistoryRoute
  AppSecretaryAreaRoute: typeof AppSecretaryAreaRoute
  AppCassaIndexRoute: typeof AppCassaIndexRoute
  AppAdminTenantsTenantIdRoute: typeof AppAdminTenantsTenantIdRouteWithChildren
  AppAdminTenantsIndexRoute: typeof AppAdminTenantsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProjectsRouteRoute: AppProjectsRouteRouteWithChildren,
  AppRolesRouteRoute: AppRolesRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppTemplatesRouteRoute: AppTemplatesRouteRouteWithChildren,
  AppTimesheetRouteRoute: AppTimesheetRouteRouteWithChildren,
  AppUsersRouteRoute: AppUsersRouteRouteWithChildren,
  AppWorkforceRouteRoute: AppWorkforceRouteRouteWithChildren,
  AppAboutRoute: AppAboutRoute,
  AppArticlesRoute: AppArticlesRouteWithChildren,
  AppAttendanceRoute: AppAttendanceRoute,
  AppBillingRoute: AppBillingRoute,
  AppCarHistoryRoute: AppCarHistoryRoute,
  AppCategoriesRoute: AppCategoriesRoute,
  AppChangelogRoute: AppChangelogRoute,
  AppDeveloperGuideRoute: AppDeveloperGuideRoute,
  AppGeneralCrudRoute: AppGeneralCrudRoute,
  AppHelpRoute: AppHelpRoute,
  AppHelpDeskAdminRoute: AppHelpDeskAdminRoute,
  AppInsightsRoute: AppInsightsRouteWithChildren,
  AppInstrumentsCalendarRoute: AppInstrumentsCalendarRoute,
  AppIntercompanyRoute: AppIntercompanyRoute,
  AppLeaveRoute: AppLeaveRoute,
  AppLegalNoticesRoute: AppLegalNoticesRoute,
  AppLegalsRoute: AppLegalsRoute,
  AppLicensingRoute: AppLicensingRoute,
  AppMaeworldRoute: AppMaeworldRoute,
  AppMediaRoute: AppMediaRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppOpenAppRoute: AppOpenAppRoute,
  AppPlanningRoute: AppPlanningRoute,
  AppProductsRoute: AppProductsRoute,
  AppProjectForecastRoute: AppProjectForecastRoute,
  AppQualityRoute: AppQualityRoute,
  AppReportingRoute: AppReportingRoute,
  AppSetupRoute: AppSetupRoute,
  AppSmartWorkingRoute: AppSmartWorkingRoute,
  AppStatisticsRoute: AppStatisticsRoute,
  AppSwitchTenantRoute: AppSwitchTenantRoute,
  AppTasksRoute: AppTasksRouteWithChildren,
  AppTicketsRoute: AppTicketsRoute,
  AppTranslateStructureRoute: AppTranslateStructureRoute,
  AppTranslationsRoute: AppTranslationsRoute,
  AppUpdateAppRoute: AppUpdateAppRoute,
  AppUploadAttachmentsRoute: AppUploadAttachmentsRoute,
  AppUserAuditRoute: AppUserAuditRoute,
  AppUserGuideRoute: AppUserGuideRoute,
  AppVehiclesRoute: AppVehiclesRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAuditLogRoute: AppAdminAuditLogRoute,
  AppAdminBrandingRoute: AppAdminBrandingRoute,
  AppAdminCategoriesRoute: AppAdminCategoriesRoute,
  AppAdminCrossTenantAccessLogsRoute: AppAdminCrossTenantAccessLogsRoute,
  AppAdminHelpDeskRoute: AppAdminHelpDeskRoute,
  AppAdminLicenseDashboardRoute: AppAdminLicenseDashboardRoute,
  AppAdminLicensePlansRoute: AppAdminLicensePlansRoute,
  AppAdminLicensesCatalogRoute: AppAdminLicensesCatalogRoute,
  AppAdminSendCommunicationsRoute: AppAdminSendCommunicationsRoute,
  AppAdminStructureLabelsRoute: AppAdminStructureLabelsRoute,
  AppAdminSystemRoute: AppAdminSystemRoute,
  AppAdminTenantManagementRoute: AppAdminTenantManagementRoute,
  AppAdminTranslateStructureRoute: AppAdminTranslateStructureRoute,
  AppAdminWorkingHoursRoute: AppAdminWorkingHoursRoute,
  AppBookingsCarHistoryRoute: AppBookingsCarHistoryRoute,
  AppSecretaryAreaRoute: AppSecretaryAreaRoute,
  AppCassaIndexRoute: AppCassaIndexRoute,
  AppAdminTenantsTenantIdRoute: AppAdminTenantsTenantIdRouteWithChildren,
  AppAdminTenantsIndexRoute: AppAdminTenantsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthAccessPermissionsRoute: typeof AuthAccessPermissionsRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRecoveryPasswordRoute: typeof AuthRecoveryPasswordRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthRegisterOtpRoute: typeof AuthRegisterOtpRoute
  AuthSelectTenantRoute: typeof AuthSelectTenantRoute
  AuthUpdatePasswordRoute: typeof AuthUpdatePasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccessPermissionsRoute: AuthAccessPermissionsRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRecoveryPasswordRoute: AuthRecoveryPasswordRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthRegisterOtpRoute: AuthRegisterOtpRoute,
  AuthSelectTenantRoute: AuthSelectTenantRoute,
  AuthUpdatePasswordRoute: AuthUpdatePasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicDownloadAppRoute: typeof PublicDownloadAppRoute
  PublicHelpDeskUnlogRoute: typeof PublicHelpDeskUnlogRoute
  PublicMaintenanceRoute: typeof PublicMaintenanceRoute
  PublicTenantFallbackRoute: typeof PublicTenantFallbackRoute
  PublicTermsCodeRoute: typeof PublicTermsCodeRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicDownloadAppRoute: PublicDownloadAppRoute,
  PublicHelpDeskUnlogRoute: PublicHelpDeskUnlogRoute,
  PublicMaintenanceRoute: PublicMaintenanceRoute,
  PublicTenantFallbackRoute: PublicTenantFallbackRoute,
  PublicTermsCodeRoute: PublicTermsCodeRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
